// ================================================
// Auth Events Utility
// For triggering auth state changes across components
// ================================================

export const triggerAuthChange = () => {
    console.log('📢 Triggering auth change event');
    window.dispatchEvent(new CustomEvent('auth-change'));
};

export const triggerLogin = (token: string, userData?: any) => {
    console.log('📢 Triggering login event');

    // Store token in localStorage
    try {
        localStorage.setItem('token', token);
        if (userData) {
            localStorage.setItem('user', JSON.stringify(userData));
        }
    } catch (error) {
        console.warn('Failed to store auth data:', error);
    }

    // Trigger auth change
    triggerAuthChange();
};

export const triggerLogout = () => {
    console.log('📢 Triggering logout event');

    // Clear auth data from localStorage
    try {
        localStorage.removeItem('token');
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        localStorage.removeItem('userData');
    } catch (error) {
        console.warn('Failed to clear auth data:', error);
    }

    // Trigger auth change
    triggerAuthChange();
};

export const getAuthToken = (): string | null => {
    try {
        // Check multiple possible token storage keys
        // authService stores as 'accessToken', but some code uses 'token' or 'authToken'
        return localStorage.getItem('accessToken') || 
               localStorage.getItem('token') || 
               localStorage.getItem('authToken') || 
               null;
    } catch (error) {
        console.warn('Failed to access localStorage:', error);
        return null;
    }
};

export const isAuthenticated = (): boolean => {
    const token = getAuthToken();
    if (!token) return false;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const now = Math.floor(Date.now() / 1000);
        return payload.exp > now;
    } catch (error) {
        return false;
    }
};
